<template>
  <div
    v-show="isOngoing || question.status !== 'send' || statistics"
    class="plv-ia-answer-question-content"
    :class="{ 'plv-ia-answer-question-content--quick': isWenda }"
  >
    <div class="plv-ia-answer-question-content__top">
      <div class="plv-ia-answer-question-content__name">{{ getLabel(question.type) }}{{ question.name }}</div>

      <div class="plv-ia-answer-question-content__options">
        <div
          v-for="(item, index) in options"
          :key="`option${index}`"
          :class="['plv-ia-answer-question-content__options__item', {
            'plv-ia-answer-right': question.itemType !== 1 && question.answer.indexOf(String.fromCharCode(65 + index)) > -1,
            'plv-ia-answer-question-content__options__item--blue': question.itemType || question.type === 'S',
            'plv-ia-answer-question-content__options__item--quick': question.itemType === 1
          }]"
        >
          <div
            :class="['plv-ia-answer-question-content__options__item__content', {
              'plv-ia-answer-progress-bar': statistics
            }]"
          >
            <span v-if="statistics" class="plv-ia-answer-progress-bar__outer">
              <span class="plv-ia-answer-progress-bar__inner" :style="`width: ${item.percent}`"></span>
            </span>
            <span
              :class="['plv-ia-answer-question-content__option__title', {
                'plv-ia-answer-question-content__option__title--normal': !statistics
              }]"
            >
              <template v-if="question.type === 'S'">{{ item.title }} {{ t('plvIA.answerCard.score') }}{{ question[`tips${index + 1}`] | scoreTips }}</template>
              <template v-else-if="question.type === 'V'">{{ index + 1 }}{{ parseInt(question.itemType) === 1 ? '' : `. ${item.title}` }}</template>
              <template v-else>{{ String.fromCharCode(65 + index) }}{{ parseInt(question.itemType) === 1 ? '' : `. ${item.title}` }}</template>
            </span>
          </div>
          <div v-if="statistics ? options[index].count : optionResults[index]" class="plv-ia-answer-question-content__options__item__count">
            <span>{{ statistics ? options[index].count : optionResults[index] }}</span>{{ t('plvIA.answerCard.person') }}
            <template v-if="statistics">({{ options[index].percent }})</template>
          </div>
        </div>
      </div>

      <div
        v-if="statistics"
        class="plv-ia-answer-question-content__result"
      >
        {{ t('plvIA.answerCard.totalSubmission') }}<span>{{ statistics.total }}</span>{{ t('plvIA.answerCard.person') }}<template v-if="question.itemType === 0 && (question.type === 'R' || question.type === 'C')">{{ t('plvIA.answerCard.correct') }}<span>{{ statistics.correctCount }}</span>{{ t('plvIA.answerCard.person') }}</template><template v-else-if="question.type === 'S'">{{ t('plvIA.answerCard.averageScore') }}<span>{{ averageScore }}</span>{{ t('plvIA.answerCard.score') }}</template>
      </div>
    </div>

    <div v-if="isOngoing" class="plv-ia-answer-question-content__bottom">
      <div v-if="!question.duration" class="plv-ia-answer-question-content__bottom__left">
        <button class="plv-ia-btn-new plv-ia-btn-orange" :disabled="isStopping" @click="handleStop">{{ question.type === 'S' ? t('plvIA.answerCard.stopRating') : t('plvIA.answerCard.stopAnswer') }}</button>
      </div>

      <div class="plv-ia-answer-question-content__bottom__right">
        <p v-if="question.duration && question.duration > 0" class="plv-ia-answer-statistics">{{ t('plvIA.answerCard.remainingTime') }}<span>{{ countdown }}s</span>{{ t('plvIA.answerCard.submitted') }}<span>{{ submittedCount }}</span>{{ t('plvIA.answerCard.person') }}</p>
        <p v-else class="plv-ia-answer-statistics">{{ t('plvIA.answerCard.submittedStatus') }}<span>{{ submittedCount }}</span>{{ t('plvIA.answerCard.person') }}</p>
      </div>
    </div>

    <div v-else-if="question.status === 'draft'" class="plv-ia-answer-question-content__bottom">
      <div class="plv-ia-answer-question-content__bottom__left">
        <button class="plv-ia-btn-new plv-ia-btn-blue" @click="handleStart(false)">{{ t('plvIA.answerCard.send') }}</button>

        <duration-setting
          :duration.sync="duration"
          :enable-limit-time.sync="enableLimitTime"
        />
      </div>

      <div class="plv-ia-answer-question-content__bottom__right">
        <button class="plv-ia-btn-new plv-ia-btn-blue" @click="handleEditClick">{{ t('plvIA.answerCard.edit') }}</button>
        <button class="plv-ia-btn-new" @click="handleDelete">{{ t('plvIA.common.delete') }}</button>
      </div>
    </div>

    <div v-else-if="question.itemType === 0" class="plv-ia-answer-question-content__bottom">
      <div class="plv-ia-answer-question-content__bottom__left">
        <button
          class="plv-ia-btn-new plv-ia-btn-blue"
          :disabled="isSent || statistics && statistics.isSentResult"
          @click="handleSendResult"
        >
          {{ isSent || statistics && statistics.isSentResult ? t('plvIA.common.sent') : t('plvIA.answerCard.sendResults') }}
        </button>
        <button class="plv-ia-btn-new" @click="handleStart(true)">{{ t('plvIA.answerCard.sendAgain') }}</button>
        <duration-setting
          :duration.sync="duration"
          :enable-limit-time.sync="enableLimitTime"
        />
      </div>

      <div class="plv-ia-answer-question-content__bottom__right">
        <button class="plv-ia-btn-new" @click="handleDelete">{{ t('plvIA.common.delete') }}</button>
      </div>
    </div>

    <div v-else-if="question.itemType === 1" class="plv-ia-answer-question-content__bottom">
      <div class="plv-ia-answer-question-content__bottom__left">
        <button class="plv-ia-btn-new plv-ia-btn-blue" @click="handleContinue">{{ t('plvIA.answerCard.continue') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash-es';
import Locale from '@/mixins/locale';
import DurationSetting from './DurationSetting';

export default {
  components: {
    DurationSetting,
  },

  filters: {
    scoreTips(txt) {
      return txt ? `（${txt}）` : '';
    }
  },
  mixins: [Locale],
  props: {
    countdown: {
      type: Number,
      default: 0,
    },
    question: {
      type: Object,
      default: null,
    },
    statistics: {
      type: Object,
      default: null,
    },
    isOngoing: {
      type: Boolean,
      default: false,
    },
    sentList: {
      type: Array,
      default() {
        return [];
      }
    },
    optionResults: {
      type: Array,
      default() {
        return [];
      }
    },
    submittedCount: {
      type: Number,
      default: 0,
    },
    isStopping: Boolean,

    channelSetting: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      enableLimitTime: this.channelSetting.defaultLimitTimeAnswer,
      duration: 8,
      TYPE_TEXT: {
        R: this.t('plvIA.answerCard.oneChoiceLabel'),
        C: this.t('plvIA.answerCard.multipleChoiceLabel'),
        S: this.t('plvIA.answerCard.scoreLabel'),
        V: this.t('plvIA.answerCard.voteLabel')
      }
    };
  },

  computed: {
    options() {
      if (this.statistics) {
        return this.statistics.options;
      } else {
        const list = [];
        for (let i = 1; i <= 15; i++) {
          const optionTxt = this.question[`option${i}`];
          // 四中账号的选项内容可以为空字符串，但其他账号选项内容不能为空字符串
          const isEmptyOption = this.channelSetting.answerContentBlankEnabled ? typeof optionTxt !== 'string' : !optionTxt;
          if (isEmptyOption) break;
          list.push({
            title: optionTxt,
          });
        }
        return list;
      }
    },

    averageScore() {
      const { statistics } = this;
      if (!statistics) return '';

      let totalScore = 0;
      statistics.options.forEach(item => {
        totalScore += parseInt(item.title) * parseInt(item.count);
      });
      let average = statistics.total > 0 ? parseFloat(totalScore / statistics.total) : 0;
      if (average % 1 !== 0) {
        average = parseFloat(average.toFixed(4));
      }

      return average;
    },

    isSent() {
      const sentListStr = this.sentList.join(' ');
      return sentListStr.indexOf(this.question.questionId) > -1;
    },

    isWenda() {
      return this.question && parseInt(this.question.itemType) === 1;
    }
  },

  watch: {
    question(val, oldVal) {
      if (oldVal && val && oldVal.questionId !== val.questionId) {
        this.duration = 8;
        this.enableLimitTime = this.channelSetting.defaultLimitTimeAnswer;
      }
    }
  },

  methods: {
    getLabel(type) {
      const label = this.TYPE_TEXT[type];
      return label ? `【${label}】` : '';
    },

    handleEditClick() {
      this.$emit('edit', this.question.questionId);
    },

    handleSendResult: debounce(function() {
      // utils.logger.info('[click btn][answer card] send result');
      this.$emit('send-result');
    }, 300),

    handleStop: debounce(function() {
      // utils.logger.info('[click btn][answer card] stop');
      this.$emit('stop');
    }, 300),

    handleStart: debounce(function(isAgain = false) {
      // utils.logger.info('[click btn][answer card] start');
      const duration = parseInt(this.duration, 10);
      if (this.enableLimitTime && !duration) {
        this.$iaMessage.default(this.t('plvIA.answerCard.enterTimeLimit'));
        return;
      }

      const data = Object.assign({}, this.question);
      data.duration = this.enableLimitTime ? duration : 0;

      this.$emit('start', data, isAgain);
    }, 300),

    handleContinue() {
      this.$emit('continue');
    },

    handleDelete() {
      this.$emit('delete');
    },
  }
};
</script>

<style lang="scss">
$blue: #2196F3;

.plv-ia-answer-question-content {
  padding: 28px 0 80px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}

.plv-ia-answer-question-content__top {
  height: 100%;
  overflow: auto;
  padding: 0 24px;
}

.plv-ia-answer-question-content__bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 24px;
  box-sizing: border-box;
}

.plv-ia-answer-question-content__name {
  color: #333;
  line-height: 19px;
  max-width: 488px;
  word-break: break-word;
}

.plv-ia-answer-question-content__options {
  padding: 20px 0;
  box-sizing: border-box;
}

.plv-ia-answer-question-content__options__item {
  position: relative;
  padding-right: 12em;
  box-sizing: content-box;

  & +.plv-ia-answer-question-content__options__item {
    margin-top: 20px;
  }

  &--quick {
    width: 96px;
  }
}

.plv-ia-answer-question-content__options__item__content {
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.plv-ia-answer-question-content__option__title {
  text-indent: -1.2em;
  width: 100%;
  display: inline-block;
  color: #546E7A;
  padding: 10px 16px;
  padding-right: 50px;
  line-height: 20px;
  border-radius: 20px;
  position: relative;
  box-sizing: border-box;
  word-break: break-word;

  &:before {
    content: '';
    width: 1.2em;
    display: inline-block;
  }

  &:after {
    content: '';
    position: absolute;
    right: 16px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 16px;
    height: 16px;
    border-radius: 20px;
    background: url(./images/icon-answer-right.png) no-repeat;
    background-size: contain;
    opacity: 0;
  }

  &--normal {
    background: #EDF1F7;
  }
}

.plv-ia-answer-progress-bar__outer {
  border: 1px solid #edf1f7;
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 20px;
}
.plv-ia-answer-progress-bar__inner {
  background: #EDF1F7;
  display: block;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 20px;
}

.plv-ia-answer-right {
  .plv-ia-answer-question-content__option__title--normal {
    background: #C0E3FF;
    color: $blue;

    &::after {
      opacity: 1;
    }
  }
}

.plv-ia-answer-right, .plv-ia-answer-question-content__options__item--blue {
  .plv-ia-answer-progress-bar__outer {
    border-color: #C0E3FF;
  }

  .plv-ia-answer-progress-bar__inner {
    background: #C0E3FF;
  }
}

.plv-ia-answer-question-content__options__item__count {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 11em;
  line-height: 40px;
  height: 40px;
  color: #546E7A;

  span {
    color: $blue;
  }
}

.plv-ia-answer-question-content__bottom__left {
  float: left;

  .plv-ia-btn-new +.plv-ia-btn-new {
    margin-left: 12px;
  }
}

.plv-ia-answer-question-content__bottom__right {
  float: right;

  .plv-ia-btn-new {
    width: 64px;

    & +.plv-ia-btn-new {
      margin-left: 12px;
    }
  }
}

.plv-ia-answer-statistics {
  line-height: 32px;
  height: 32px;

  span {
    font-size: 20px;
    color: #45ACFF;
    font-weight: bold;
    margin: 0 .2em;
  }
}

.plv-ia-answer-question-content__result {
  span {
    font-size: 24px;
    color: #45ACFF;
    font-weight: bold;
    margin: 0 .2em;
  }
}
</style>
